export default {"src":"/_next/static/media/logo.5b8bf236.svg","height":24,"width":76,"blurWidth":0,"blurHeight":0};